import axios from "axios";
import authHeader from "@/services/auth-header";

const API_URL = `${process.env.VUE_APP_API_BASE_URL}/api/Feature/Auth`;

class AuthService {
  sendRecoveryLink(userName) {
    return axios
      .get(
        `${API_URL}/Send/RecoveryLink?userName=${encodeURIComponent(userName)}`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }
}

export default new AuthService();
